module.exports = __webpack_public_path__ + "media/scholarship_winners/trophy-91659f67.png";